module.exports = __webpack_public_path__ + "img/goods11.088d1ae2.jpg";